<template>
	<span>{{formatedDate}}</span>
</template>
<script>
	export default{
		props: {
			date:{
				type: String
			},
		},
		computed: {
			formatedDate: function () {
				if(!this.date) return null;
				let date = new Date(this.date);
				let options = { year: 'numeric', month: '2-digit', day: '2-digit' };//weekday: 'numeric' long,
				return date.toLocaleDateString('fr-FR', options);
			},
		},
	}
</script>